"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsCustomForm = NewsCustomForm;
exports.NewsCustomFormContent = NewsCustomFormContent;
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _FormControl2 = _interopRequireDefault(require("@mui/material/FormControl"));
var _Select2 = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem2 = _interopRequireDefault(require("@mui/material/MenuItem"));
var _ListItemText2 = _interopRequireDefault(require("@mui/material/ListItemText"));
var _ListItemAvatar2 = _interopRequireDefault(require("@mui/material/ListItemAvatar"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _formik = require("formik");
var _notistack = require("notistack");
var _quill = _interopRequireDefault(require("quill"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var Yup = _interopRequireWildcard(require("yup"));
var _components = require("../components");
var _hooks = require("../hooks");
var _services = require("../services");
require("quill/dist/quill.snow.css");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Link = _quill.default.import('formats/link');
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto'];
class CustomLinkSanitizer extends Link {
  static sanitize(url) {
    const sanitizedUrl = super.sanitize(url);
    if (!sanitizedUrl || sanitizedUrl === 'about:blank') return sanitizedUrl;
    const hasWhitelistedProtocol = this.PROTOCOL_WHITELIST.some(protocol => sanitizedUrl.startsWith(protocol));
    if (hasWhitelistedProtocol) return sanitizedUrl;
    return `https://${sanitizedUrl}`;
  }
}
_quill.default.register(CustomLinkSanitizer, true);
function NewsCustomForm({
  Link,
  prevPath,
  newsPost,
  backendUrl,
  currentUser,
  userType,
  currentPartner,
  geogroup,
  drawerWidth,
  onCreated
}) {
  const [photo, setPhoto] = (0, _react.useState)(newsPost?.photo ? {
    url: `${backendUrl}${newsPost.photo}`,
    name: newsPost.photo.substring(newsPost.photo.lastIndexOf('/') + 1)
  } : undefined);
  const {
    isValid,
    isSubmitting,
    values,
    setFieldValue,
    handleSubmit
  } = (0, _formik.useFormik)({
    initialValues: {
      creator: 'user',
      content: newsPost?.text || ''
    },
    validationSchema: Yup.object().shape({
      content: Yup.string().required()
    }),
    onSubmit,
    enableReinitialize: true
  });
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    return () => cancelPromises();
  }, []);
  async function onSubmit({
    creator,
    content
  }, {
    setSubmitting
  }) {
    if (!geogroup) return;
    setSubmitting(true);
    try {
      if (newsPost) {
        await cancellablePromise(_services.GeogroupService.updateNewsPost(geogroup.id, newsPost.id, {
          author_type: userType === 'admin' && geogroup && creator === 'geogroup' ? 'AUTHOR_AS_GROUP' : 'AUTHOR_AS_MEMBER',
          text: content,
          photo: photo instanceof File || photo === null ? photo : undefined
        }, currentPartner));
        enqueueSnackbar(t('commons.news_form.success_update'));
      } else {
        await cancellablePromise(_services.GeogroupService.addNewsPost(geogroup.id, {
          author_type: userType === 'admin' && geogroup && creator === 'geogroup' ? 'AUTHOR_AS_GROUP' : 'AUTHOR_AS_MEMBER',
          text: content,
          photo: photo instanceof File ? photo : undefined,
          geo_group: geogroup.id
        }, currentPartner));
        enqueueSnackbar(t('commons.news_form.success_creation'));
      }
      onCreated?.();
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t(newsPost ? 'commons.news_form.server_error_update' : 'commons.news_form.server_error_creation'), {
          variant: 'error'
        });
      }
    }
    setSubmitting(false);
  }
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_Card2.default, {
    sx: {
      alignSelf: 'stretch',
      borderRadius: 4,
      marginBottom: '58px'
    },
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_CardContent2.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      padding: 3
    }
  }, /*#__PURE__*/_react.default.createElement(NewsCustomFormContent, {
    backendUrl: backendUrl,
    currentUser: currentUser,
    geogroup: geogroup,
    isSubmitting: isSubmitting,
    newsPost: newsPost,
    photo: photo,
    setFieldValue: setFieldValue,
    setPhoto: setPhoto,
    userType: userType,
    values: values
  }))), /*#__PURE__*/_react.default.createElement(_components.StickyBar, {
    drawerWidth: drawerWidth
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    color: "primary",
    component: Link,
    disabled: isSubmitting,
    size: "large",
    startIcon: /*#__PURE__*/_react.default.createElement(_Close2.default, null),
    sx: {
      borderRadius: '8px !important'
    },
    to: prevPath,
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/_react.default.createElement(_components.Button, {
    disableElevation: true,
    color: "primary",
    disabled: !isValid || isSubmitting || !values.content,
    size: "large",
    startIcon: isSubmitting ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_components.SendIcon, null),
    sx: {
      borderRadius: '8px !important'
    },
    type: "submit",
    variant: "contained"
  }, t(newsPost ? 'commons.actions.update' : 'commons.news_form.actions.post')))));
}
function NewsCustomFormContent({
  backendUrl,
  newsPost,
  currentUser,
  userType,
  geogroup,
  values,
  photo,
  isSubmitting,
  setFieldValue,
  setPhoto
}) {
  const [initialized, setInitialized] = (0, _react.useState)(false);
  const quillRef = (0, _react.useRef)(null);
  const quillContentEditorRef = (0, _react.useRef)(null);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    setInitialized(true);
  }, []);
  (0, _react.useEffect)(() => {
    if (initialized) {
      quillRef.current = new _quill.default('#content-editor', {
        bounds: '#content-editor-wrapper',
        placeholder: t('commons.news_form.content_placeholder'),
        theme: 'snow',
        modules: {
          toolbar: ['bold', 'italic', 'underline', 'link']
        }
      });
      quillRef.current.clipboard.addMatcher(Node.ELEMENT_NODE, (_, delta) => {
        const ops = [];
        delta.ops.forEach(op => {
          if (op.insert && typeof op.insert === 'string') {
            ops.push({
              insert: op.insert
            });
          }
        });
        delta.ops = ops;
        return delta;
      });
      quillRef.current.on('text-change', (_, __, source) => {
        if (source === 'user') {
          setFieldValue('content', quillRef.current?.getSemanticHTML() || '');
        }
      });
      if (newsPost?.text && quillContentEditorRef.current) {
        const editor = quillContentEditorRef.current.getElementsByClassName('ql-editor')[0];
        if (editor) editor.innerHTML = newsPost.text;
      }
    }
  }, [initialized]);
  (0, _react.useEffect)(() => {
    if (geogroup !== undefined && newsPost) {
      setPhoto(newsPost.photo ? {
        url: `${backendUrl}${newsPost.photo}`,
        name: newsPost.photo.substring(newsPost.photo.lastIndexOf('/') + 1)
      } : undefined);
      setFieldValue('creator', userType === 'admin' && geogroup && newsPost.postedByGroup ? 'geogroup' : 'user');
      if (newsPost.text && quillContentEditorRef.current) {
        const editor = quillContentEditorRef.current.getElementsByClassName('ql-editor')[0];
        if (editor) editor.innerHTML = newsPost.text;
      }
    }
  }, [geogroup, newsPost]);
  (0, _react.useEffect)(() => {
    if (newsPost === undefined || isSubmitting) quillRef.current?.disable();else quillRef.current?.enable();
  }, [newsPost, isSubmitting]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, newsPost === null && userType === 'admin' && geogroup && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600
  }, t('commons.news_form.author_label')), /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    margin: "none",
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Select2.default, {
    disabled: newsPost === undefined || isSubmitting,
    onChange: ({
      target: {
        value
      }
    }) => setFieldValue('creator', value),
    size: "small",
    sx: {
      '> div': {
        display: 'flex'
      }
    },
    value: values.creator
  }, /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    value: "user"
  }, /*#__PURE__*/_react.default.createElement(_ListItemAvatar2.default, {
    sx: {
      minWidth: 40
    }
  }, currentUser ? /*#__PURE__*/_react.default.createElement(_components.UserAvatar, {
    user: currentUser
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 32,
    variant: "circular",
    width: 32
  })), /*#__PURE__*/_react.default.createElement(_ListItemText2.default, {
    primary: currentUser?.username || '-'
  })), /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    value: "geogroup"
  }, /*#__PURE__*/_react.default.createElement(_ListItemAvatar2.default, {
    sx: {
      minWidth: 40
    }
  }, /*#__PURE__*/_react.default.createElement(_components.GeogroupAvatar, {
    geogroup: geogroup
  })), /*#__PURE__*/_react.default.createElement(_ListItemText2.default, {
    primary: geogroup.title
  }))))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600
  }, t('commons.news_form.content_label'), " *"), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    id: "content-editor-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    id: "content-editor",
    ref: quillContentEditorRef
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600
  }, t('commons.news_form.image_label')), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_components.FileInput, {
    disablePreview: true,
    disabled: newsPost === undefined || isSubmitting,
    file: photo,
    onChange: setPhoto,
    size: "small",
    type: "image"
  }), photo && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignSelf: "flex-start",
    padding: "12px 12px 0 0",
    position: "relative"
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: 80,
    src: 'url' in photo ? photo.url : URL.createObjectURL(photo),
    style: {
      borderRadius: 4
    }
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    position: "absolute",
    right: 0,
    top: 0
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "rgba(0, 0, 0, 0.8)",
    borderRadius: "50%",
    color: "#fff"
  }, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    title: t('commons.actions.remove')
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    color: "inherit",
    onClick: () => setPhoto(null),
    size: "small",
    sx: {
      padding: 0.5
    }
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, {
    fontSize: "small"
  })))))))));
}